import { render, staticRenderFns } from "./ad-authorize-modal.vue?vue&type=template&id=a8d0154a&scoped=true&"
import script from "./ad-authorize-modal.vue?vue&type=script&lang=js&"
export * from "./ad-authorize-modal.vue?vue&type=script&lang=js&"
import style0 from "./ad-authorize-modal.vue?vue&type=style&index=0&id=a8d0154a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d0154a",
  null
  
)

export default component.exports